import Vue from 'vue';
import Vuex from 'vuex';
import Cookie from "js-cookie";
import {VueApp} from '@/main';
import VueCookies from 'vue-cookies'
import Keycloak from "@/assets/js/keycloak";
import {getArchiveModeDetailsByVersion} from "@/shared/archive-mode-utils";
import {LOGIN_METHOD} from "@/shared/constants/loginMethod";
import {addQueryParams} from "@/shared/utils";

export const TITLE = "TITLE";
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_RESET = "LOGIN_RESET";
export const PROFILE = "PROFILE";
export const CURRENCIES = "CURRENCIES";
export const LOGOUT = "LOGOUT";
export const MAIN_LOADING = "MAIN_LOADING";
export const SIDEBAR_TOGGLE = "SIDEBAR_TOGGLE";
export const SIDEBAR_TOGGLE_MINI = "SIDEBAR_TOGGLE_MINI";
export const SIDEBAR_TOGGLE_MOBILE = "SIDEBAR_TOGGLE_MOBILE";
export const OTHER_HOST = "OTHER_HOST";
export const LOGGING_IN_VIA_KEYCLOAK = "LOGGING_IN_VIA_KEYCLOAK";
export const LOGGING_METHOD = "LOGGING_METHOD";
export const ARCHIVE_MODE_VERSION = "ARCHIVE_MODE_VERSION";

Vue.use(Vuex);

const AppStore = new Vuex.Store({
    state: {
        profile: {},
        isAdmin: false,
        isRegionalLeader: false,
        mainLoading: false,
        isLoggedIn: false,
        loginProgress: false,
        loginError: '',
        sidebar: {
            open: true,
            mini: localStorage.getItem('x_sidebar_mini') === 'y',
            mobile: false
        },
        navbar: {
            title: ''
        },
        currencies: [],
        hostName: (window.location != window.parent.location)? document.referrer: document.location.href,//window.parent.location
        cookieTokenName: 'x_token_' + process.env.VUE_APP_NAME,
        keycloak: new Keycloak({
            url: process.env.VUE_APP_KEYCLOAK_API_URL,
            realm: process.env.VUE_APP_KEYCLOAK_REALM,
            clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
            onLoad: 'login-required'
        }),
        isLoggingInViaKeycloak: false,
        loginMethod: LOGIN_METHOD.SIMPLE,
        archiveModeVersion: ''
    },
    mutations: {
        [TITLE](state, payload) {
            state.navbar.title = payload;
        },
        [LOGIN](state) {
            state.loginProgress = true;
        },
        [LOGIN_SUCCESS](state) {
            state.loginProgress = false;
            state.isLoggedIn = true;
        },
        [LOGIN_FAILURE](state) {
            state.loginProgress = false;
            state.isLoggedIn = false;
            state.loginError = 'Имя пользователя и / или пароль недействительны';
        },
        [LOGIN_RESET](state) {
            state.loginError = '';
        },
        [LOGOUT](state) {
            state.isLoggedIn = false;
            state.profile = {};
            state.isAdmin = false;
            state.isRegionalLeader = false;
        },
        [PROFILE](state, payload) {
            state.isLoggedIn = true;
            state.profile = payload;
            state.isAdmin = false;
            state.isRegionalLeader = false;
            if (state.profile && state.profile.authorities && state.profile.authorities.length > 0) {
                for (const role of state.profile.authorities) {
                    if (role === 'ROLE_ADMIN') {
                        state.isAdmin = true;
                    }
                    if (role === 'ROLE_REGIONAL_LEADER') {
                        state.isRegionalLeader = true;
                    }
                }
            }
        },
        [CURRENCIES](state, payload) {
            state.currencies = payload;
            state.isLoggedIn = true;
        },
        [MAIN_LOADING](state, loading) {
            state.mainLoading = loading;
        },
        [SIDEBAR_TOGGLE](state) {
            state.sidebar.open = !state.sidebar.open;
        },
        [SIDEBAR_TOGGLE_MINI](state) {
            state.sidebar.mini = !state.sidebar.mini;
            localStorage.setItem('x_sidebar_mini', (state.sidebar.mini ? 'y' : 'n'));
        },
        [SIDEBAR_TOGGLE_MOBILE](state) {
            state.sidebar.mobile = !state.sidebar.mobile;
        },
        [OTHER_HOST](state) {
            const url = state.hostName;
            const token = Cookie.get(state.cookieTokenName);
            if (url && (!token || token == null || token==='undefined')) {
                var parts = url.split('://');
                if (parts.length > 1) {
                    const baseUrl = parts[1].split('/')[0];
                    if (baseUrl==='e-baholash.uz' || baseUrl.includes('127.0.0.1')){
                        const x_token = new URL(document.location.href).searchParams.get('x_token');
                        console.log(x_token);
                        Cookie.set('x_token', x_token, {});
                    }
                }
            }
        },
        [LOGGING_IN_VIA_KEYCLOAK](state, value) {
            state.isLoggingInViaKeycloak = value
        },
        [LOGGING_METHOD](state, value) {
            state.loginMethod = value;
            Cookie.set('login_method', value);
        },
        [ARCHIVE_MODE_VERSION](state, version){
            state.archiveModeVersion = version;
            if(state.isLoggedIn) {
                Cookie.set('archive_version', version);
            }
            let versionDetails = getArchiveModeDetailsByVersion(version);
            VueApp.$http.defaults.baseURL = versionDetails.url;
            document.documentElement.style.setProperty('--warn-color', versionDetails.color);
        }
    },
    actions: {
        initTitle({commit}, title) {
            commit(TITLE, title);
        },
        logIn({commit, dispatch, state}, creds) {
            commit(LOGIN); // show spinner
            return new Promise(resolve => {
                VueApp.$http.post('/login', creds)
                    .then(res => {
                        this.loading = false;
                        res = res.data;
                        if (res.status && res.status === 'SUCCESS') {
                            localStorage.setItem(state.cookieTokenName, res.data.token);
                            Cookie.set(state.cookieTokenName, res.data.token, {domain: process.env.VUE_APP_ROOT_DOMAIN});
                            commit(LOGGING_METHOD, LOGIN_METHOD.SIMPLE);
                            commit(LOGIN_SUCCESS);
                            if(VueApp.$route.query && VueApp.$route.query.archiveVersion) {
                                commit(ARCHIVE_MODE_VERSION, (VueApp.$route.query.archiveVersion || ''));
                            }
                            VueApp.$router.push('/real-estate');
                            dispatch('initProfile', false);
                        } else {
                            commit(LOGIN_FAILURE);
                        }
                        resolve();
                    }, err => {
                        console.log(err);
                        commit(LOGIN_FAILURE);
                        VueCookies.remove(state.cookieTokenName, '/', process.env.VUE_APP_ROOT_DOMAIN);
                        Cookie.remove(state.cookieTokenName);
                        localStorage.clear();
                        localStorage.removeItem(state.cookieTokenName);
                        resolve();
                    });
            });
        },
        logInReset({commit}) {
            commit(LOGIN_RESET);
        },
        logOut({commit, state}) {
            VueCookies.remove(state.cookieTokenName, '/', process.env.VUE_APP_ROOT_DOMAIN);
            Cookie.remove(state.cookieTokenName);
            Cookie.remove('archive_mode');
            Cookie.remove('archive_version');
            commit(LOGGING_METHOD, LOGIN_METHOD.SIMPLE)
            localStorage.clear();
            localStorage.removeItem(state.cookieTokenName);
            if(state.keycloak && state.keycloak.authenticated) {
                state.keycloak.logout({redirectUri: VueApp.$route.query.archiveVersion
                        ? `${process.env.VUE_APP_WEB_URL}real-estate?archiveVersion=${VueApp.$route.query.archiveVersion}`
                        : `${process.env.VUE_APP_WEB_URL}real-estate`
                })
            }
            commit(LOGOUT);
        },
        initProfile({commit, state}, redirect) {
            const tokenCheck = Cookie.get(state.cookieTokenName);
            if (!tokenCheck || tokenCheck === null || tokenCheck==='undefined') {
                commit(OTHER_HOST);//e-baholash iframe
            }
            const token = Cookie.get(state.cookieTokenName);
            if (token && token.length > 0) {
                VueApp.$http.get('profile')
                    .then(res => {
                        res = res.data;
                        if (res.id && res.id > 0) {
                            commit(PROFILE, res);
                            if (redirect) {
                                const path = window.location.pathname;
                                // console.log('current_path', path);
                                if (!path || path === '' || path === '/') {
                                    VueApp.$router.push('/real-estate');
                                }
                            }
                        } else if (redirect) {
                            //VueApp.goToLogin();
                        }
                        commit(MAIN_LOADING, false);
                        commit(LOGGING_IN_VIA_KEYCLOAK, false)
                    }, err => {
                        console.log(err);
                        //VueApp.goToLogin();
                    });
            } else {
                //VueApp.goToLogin();
                commit(MAIN_LOADING, false);
                commit(LOGGING_IN_VIA_KEYCLOAK, false)
            }
        },
        sideBarToggle({commit}) {
            commit(SIDEBAR_TOGGLE);
        },
        sideBarToggleMini({commit}) {
            commit(SIDEBAR_TOGGLE_MINI);
        },
        sideBarToggleMobile({commit}) {
            commit(SIDEBAR_TOGGLE_MOBILE);
        },
        authenticateByIdToken({commit, state, dispatch}, idToken) {
            VueApp.$http.post('/keycloak-auth', {idToken}).then(res => {
                res = res.data;
                if (res.status && res.status === 'SUCCESS') {
                    localStorage.setItem(state.cookieTokenName, res.data.token);
                    Cookie.set(state.cookieTokenName, res.data.token, {domain: process.env.VUE_APP_ROOT_DOMAIN});
                    commit(LOGGING_METHOD, LOGIN_METHOD.KEYCLOAK);
                    commit(LOGIN_SUCCESS);
                    if(VueApp.$route.query && VueApp.$route.query.archiveVersion) {
                        commit(ARCHIVE_MODE_VERSION, (VueApp.$route.query.archiveVersion || ''));
                    }
                    let lastRoutePath = VueApp.$route.query && VueApp.$route.query.from ? VueApp.$route.query.from : VueApp.$route.path
                    VueApp.$router.push(lastRoutePath)
                    dispatch('initProfile', false);
                } else {
                    commit(LOGIN_FAILURE);
                    commit(LOGGING_IN_VIA_KEYCLOAK, false)
                }
            }).catch((err) => {
                console.log(err);
                commit(LOGIN_FAILURE);
                commit(LOGGING_IN_VIA_KEYCLOAK, false)
                VueCookies.remove(state.cookieTokenName, '/', process.env.VUE_APP_ROOT_DOMAIN);
                Cookie.remove(state.cookieTokenName);
                localStorage.clear();
                localStorage.removeItem(state.cookieTokenName);
            });
        },
        authenticateViaKeycloak({commit, state, dispatch}) {
            if(state.keycloak && !state.keycloak.authenticated) {
                commit(LOGIN);
                commit(LOGGING_IN_VIA_KEYCLOAK, true)
                state.keycloak.init({}).then((auth) => {
                    if (!auth){
                        let redirectUri = `${process.env.VUE_APP_WEB_URL}real-estate?loggedViaKeycloak=true`
                        if(VueApp.$route.query.archiveVersion) {
                            redirectUri += `&archiveVersion=${VueApp.$route.query.archiveVersion}`
                        }
                        if(VueApp.$route.path !== '/' && VueApp.$route.path !== '/real-estate') {
                            redirectUri += `&from=${VueApp.$route.path}`
                        }
                        state.keycloak.login({redirectUri: redirectUri})
                    } else if(auth) {
                        dispatch('authenticateByIdToken', state.keycloak && state.keycloak.idToken ? state.keycloak.idToken : null)
                    }
                }).catch(error => {
                    console.log(error)
                    commit(LOGGING_IN_VIA_KEYCLOAK, false)
                });
            }
        },
        toggleArchiveMode(vuexContext, archiveVersion) {
            let params = {}
            if(archiveVersion) {
                params.archiveVersion = archiveVersion
            }
            if(vuexContext.state.loginMethod === LOGIN_METHOD.KEYCLOAK) {
                params.loggedViaKeycloak = true
            }
            VueApp.$router.push(addQueryParams('/real-estate', params));
            vuexContext.dispatch('logOut')
        }
    }
});

export default AppStore;